import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseSingleColumnImageButtonComponent } from './base-single-column-image-button/base-single-column-image-button.component';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';

@Component({
  selector: 'app-c-single-column-image-button',
  imports: [
    SHeaderComponent,
    BaseSingleColumnImageButtonComponent
  ],
  templateUrl: './c-single-column-image-button.component.html',
  styleUrl: './c-single-column-image-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CSingleColumnImageButtonComponent extends CBaseComponent implements OnInit {
  override ngOnInit() {
    console.log('SINGLE IMAGE BUTTON COMP INIT')
    this.singleLabels = [ElementsType.ComponentHeader, ElementsType.BaseSingleColumnImageButton];
    super.ngOnInit();
  }
}
